<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  definition: { type: Object, required: true },
  enabled: { type: Boolean, default: false },
  expanded: { type: Boolean, default: false },
  correctionCount: { type: Number, default: 0 },
  participantsCount: { type: Number, default: 0 },
  readOnly: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle', 'toggleExpanded']);
const { t } = useI18n();
const toggle = event => emit('toggle', event);
const toggleExpanded = () => emit('toggleExpanded');
</script>

<template>
  <div class="flex flex-wrap items-center gap-3 p-4 sm:flex-nowrap">
    <label
      class="flex min-w-0 flex-1 items-center gap-3 text-sm font-semibold text-lais-text"
    >
      <input
        type="checkbox"
        class="size-4 rounded border-lais-border text-lais-primary"
        :checked="enabled"
        :disabled="readOnly || !participantsCount"
        @change="toggle"
      />
      {{ definition.title }}
    </label>
    <span
      v-if="enabled"
      class="rounded-full bg-red-50 px-2 py-1 text-xs font-bold text-red-700"
    >
      {{
        t('SALES.REVIEW.RETURN_FORM.CORRECTION_COUNT', {
          count: correctionCount,
        })
      }}
    </span>
    <p v-else class="min-w-0 flex-1 text-sm text-lais-text-muted">
      {{ definition.description }}
    </p>
    <button
      v-if="enabled"
      type="button"
      class="grid size-8 place-items-center rounded-lais-sm text-lais-text-muted hover:bg-lais-bg-soft"
      :aria-label="t('SALES.REVIEW.RETURN_FORM.TOGGLE')"
      @click="toggleExpanded"
    >
      <span
        class="size-4"
        :class="expanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
        aria-hidden="true"
      />
    </button>
  </div>
</template>
